import React from "react";
import "./Footer.css";
// import ReactDOM from "react-dom";


const Footer = () => {
    return (
        <div>
            <div className="footer-container">
                <small>Copyright ©2020 by Istiak Iqbal <br /> All rights reserved.</small>
            </div>
        </div >
    );
};

export default Footer;